import styles from "./style.module.css";

import { BsColumnsGap } from "react-icons/bs";
import { FiSettings } from "react-icons/fi";
import { MdLogout } from "react-icons/md";
import { FaRegAddressBook } from "react-icons/fa";
import { NavButton } from "../NavButton/NavButton";
import { BiArrowBack } from "react-icons/bi";

import { useContext } from "react";
import mainContext from "../../../context/mainContext";

import img1 from "./image1.svg";
import img2 from "./image2.svg";
import img3 from "./LogoReadMateLogo.png"
import { useNavigate } from "react-router-dom";
import dataContext from "../../../context/dataContext";
import authRequets from "../../api/authRequests";

// creator: shmuel asherov team-f
export const NavBar = () => {
  const {
    nav: { setIsShowNav },
    loader: { setLoaderFetch }
  } = useContext(mainContext);
  const navigate = useNavigate()
  const handleOpenNav = (to) => {
    setIsShowNav((old) => !old);
    if (to) {
      navigate(to);
    }
  };

  const { setUserDetails } = useContext(dataContext);

  const signOut = async () => {
    setLoaderFetch(true);
    await authRequets.logOut();
    setIsShowNav(false);
    setUserDetails(null);
    setLoaderFetch(false);
    navigate("/")
  };

  return (
    <>
      <div
        className={`${styles.opacity}`}
        onClick={() => setIsShowNav(false)}
      ></div>

      <NavBackButt setClose={() => handleOpenNav()} />
      <div className={`${styles.box}`}>
        <ul>
          <li className={`${styles.logo}`} onClick={() => handleOpenNav("/")}>
            <img src={img1} alt="logo" />
            <img src={img2} alt="logo" />
          </li>
          <li>
            <NavButton
              onClick={() => handleOpenNav("/")}
              icon={<BsColumnsGap className={`${styles.icon}`} size="30px" />}
              text="Dashboard"
              link="/"
            />
          </li>
          <li>
            <NavButton
              onClick={() => handleOpenNav("/settings")}
              icon={<FiSettings className={`${styles.icon}`} size="30px" />}
              text="Settings"
              link="settings"
            />
          </li>
          <li>

            <NavButton
              onClick={() => handleOpenNav("/contact-us")}
              icon={
                <FaRegAddressBook className={`${styles.icon}`} size="30px" />
              }
              text="Contact Us"
              link="contact-us"
            />
          </li>
          <li>
            <NavButton
              onClick={signOut}
              icon={<MdLogout className={`${styles.icon}`} size="30px" />}
              text="Sign Out"
              link="/"
            />
          </li>
        </ul>
      </div>
    </>
  );
};

const NavBackButt = ({ setClose }) => (
  <div type="button" className={styles["arrow"]} onClick={setClose}>
    <BiArrowBack />
  </div>
);
